// extracted by mini-css-extract-plugin
export default {"tab":"Payments_tab__Xs1uv","paymentType":"Payments_paymentType__UKi9-","dropdownField":"Payments_dropdownField__MD0BD"};